<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 수행평가 대상</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>부서(업체)명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" class="w-full flex-1" :fieldId="form.stdInfo.field_id" v-model="form.inputA_1" placeholder="선택" @select="targetCompany"> </CompanySelector>
        </div>
        <div>
          <div>피평가자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 구분</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '상반기'" style="text-align: center; align-self: center">
            <vs-icon icon="check" size="small"></vs-icon>
          </div>
          <div v-else class="item-box-check"></div>
          상반기
        </template>
        <vs-checkbox v-else class="item-box-check" :checked="form.checked === '상반기'" @change="checkForm($event, '상반기')">상반기</vs-checkbox>
      </div>

      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '하반기'" style="text-align: center; align-self: center">
            <vs-icon icon="check" size="small"></vs-icon>
          </div>
          <div v-else class="item-box-check"></div>
          하반기
        </template>
        <vs-checkbox v-else class="item-box-check" :checked="form.checked === '하반기'" @change="checkForm($event, '하반기')">하반기</vs-checkbox>
      </div>
    </div>

    <!-- 업무 수행 여부 -->
    <table-evaluation :is-print="isPrint" class="mt-5" title="업무 수행 여부" sumText="계" :thTitles="['내용', '배점', '평가점수']" inputAfter="점" rowTitleColor="#F9F9F9" :list="form.evaluationList" @userScore="form.userScore = $event" />

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableEvaluation from "@/components/TableEvaluation";

export default {
  components: {
    PhotoUploadGridModule,
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
    TableEvaluation,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    evaluationTable() {
      return [
        {
          id: 1,
          label: "1. 안전보건관리 조직 운영",
          childs: [
            {
              label: "• 안전보건관리책임자 지정 및 직무교육 실시",
              max: 10,
              value: null,
            },
            {
              label: "• 안전보건관리규정 작성/변경",
              max: 10,
              value: null,
            },
            {
              label: `• 종사자 의견 청취
                <span class="ml-3">· 산업안전보건위원회 분기별 운영 여부</span>
                <span class="ml-3">· 위험성 평가 시 종사자 의견 청취</span>`,
              max: 10,
              value: null,
            },
          ],
        },
        {
          id: 2,
          label: "2. 교육 및 위험성 평가",
          childs: [
            {
              label: "• 산업재해 예방계획의 수립",
              max: 10,
              value: null,
            },
            {
              label: "• 안전보건교육 계획 수립 및 실적",
              max: 10,
              value: null,
            },
            {
              label: "• 유해·위험요인 확인·개선(위험성평가 등), 안전장치 및 보호구 구입 등 이행",
              max: 10,
              value: null,
            },
          ],
        },
        {
          id: 3,
          label: "3. 보건관리",
          childs: [
            {
              label: "• 유해인자의 노출평가 등 작업환경의 점검 개선",
              max: 10,
              value: null,
            },
            {
              label: "• 근로자 건강진단 계획 수립 및 실시",
              max: 10,
              value: null,
            },
          ],
        },
        {
          id: 4,
          label: "4. 산업재해 기록 및 관리",
          childs: [
            {
              label: "• 중대재해 발생시 원인 조사 및 재발방지대책 수립·이행",
              max: 10,
              value: null,
            },
            {
              label: "• 산업재해 기록·유지 등 통계 분석 관리",
              max: 10,
              value: null,
            },
          ],
        },
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.evaluationList || this.form.evaluationList.length === 0) {
          this.form.evaluationList = this.evaluationTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        companyName: "",
        photoList: [],
        checked: "",

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        userScore: 0,
        evaluationList: [],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    checkForm(value, text) {
      this.form.checked = text;
    },
  },
};
</script>

<style scoped lang="scss"></style>
